/** @format */
import { BufferedMeasurementsStatus } from '@mpb-com/feather/hooks/use-buffered-mesurements';
import styled, { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { StyledListingTileProps } from './types';

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = css`
    padding: 0.4rem;
    display: flex;

    .tile-background {
        flex-direction: column;
        width: 100%;
    }

    .tile {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        gap: 2rem;
        width: 100%;

        ${smallTablet(css`
            height: 30rem;
        `)}
    }

    .tile-image {
        position: relative;
        flex: 1 1 auto;

        img {
            object-fit: cover;
        }
    }

    .tile-heading {
        flex: 0 1 auto;
        margin: 0;
    }

    .skeleton-image {
        width: 100%;
        height: 100%;
    }

    .tile {
        z-index: 1;
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

const measuredStyles = ({ measurements, status }: StyledListingTileProps) => {
    const isMeasured =
        measurements && status === BufferedMeasurementsStatus.FINISHED;

    if (!isMeasured) {
        return;
    }

    const staticContainerHeight = measurements.container.height;
    return css`
        height: ${staticContainerHeight}px !important;
    `;
};

export const styles = (props: StyledListingTileProps) => css`
    ${baseStyles}
    ${measuredStyles(props)}
`;

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledListingTile = styled.div<StyledListingTileProps>`
    ${styles}
`;
